import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <>
            <section className="footer-section pt-5 mb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                            <div className='text-center icon-link'>
                                <i className="fa-solid fa-truck"></i>
                                <span>Free shipping Available</span>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                            <div className='text-center icon-link'>
                                <i className="fa-solid fa-rotate-left"></i>
                                <span>30 Day Returns</span>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                            <div className='text-center icon-link'>
                                <i className="fa-regular fa-gem"></i>
                                <span>Lifetime Diamond Warranty</span>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className='text-center icon-link'>
                                <i className="fa-solid fa-leaf"></i>
                                <span>Sustainability</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="footer-menu pt-5 pb-3">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-sm-6">
                            <img src={require('../assets/New-logo.png')} alt="" className='footer-logo' />
                            <p className='mt-3'>At Maitri Lab Grown Diamond, we design with care to create something unique, elegant and personal.</p>
                        </div>
                        <div className="col-lg-3 d-none d-lg-block"></div>
                        <div className="col-lg-4 col-sm-6 align-self-end">
                            <p className='mb-3'><b>Send me Maitri LGD news, updates and offers.</b></p>

                            <div>
                                <form action="" className='m-0 p-0 w-100'>
                                    <div className="input-group mb-3">
                                        <input type="text" className="form-control" placeholder="Recipient's Email" aria-label="Recipient's email" aria-describedby="basic-addon2" />
                                        <div className="input-group-append">
                                            <button className="btn btn__primary" type="button">Subscribe</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="row pt-md-5 mt-4">
                        <div className="col-lg-3 col-sm-6 mb-5">
                            <h4>About</h4>
                            <ul className='mb-0'>
                                <li><a href="#">Our Story</a></li>
                                <li><a href="#">Beyond Conflict Free TM</a></li>
                                <li><a href="#">Recycled Gold</a></li>
                                <li><a href="#">Maitri LGD Reviews</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-3 col-sm-6 mb-5">
                            <h4>Education</h4>
                            <ul className='mb-0'>
                                <li><a href="#">Blog</a></li>
                                <li><a href="#">Diamond Buying Guide</a></li>
                                <li><a href="#">Lab Grown Diamonds</a></li>
                                <li><a href="#">Moissanite vs. Diamonds</a></li>
                                <li><a href="#">Ring Size Chart</a></li>
                                <li><a href="#">Careers</a></li>
                                <li><a href="#">Investor Relations</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-3 col-sm-6 mb-5">
                            <h4>Orders</h4>
                            <ul className='mb-0'>
                                <li><a href="#">Track Your Order</a></li>
                                <li><a href="#">Free 30 Day Returns</a></li>
                                <li><a href="#">Free Shipping Both Ways</a></li>
                                <li><a href="#">Free Lifetime Warranty</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <h4>Contact us</h4>
                            <ul className='mb-0'>
                                <li><a href="#">Live Chat</a></li>
                                <li><a href="#">Book Appointment</a></li>
                                <li><a href="#">Stores</a></li>
                                <li><a href="#">Email Us</a></li>
                                <li><a href="#">Affiliates</a></li>
                            </ul>
                        </div>
                    </div>

                    <div className="row mt-5 footer-bar">
                        <div className="col-sm-6"><a href="#">© 2023 Maitri Lab Grown Diamonds. ALL RIGHTS RESERVED</a></div>
                        <div className="col-sm-6">
                            <div className='d-flex justify-content-end'>
                                <a href="#" className='d-block me-4'>SITEMAP</a>
                                <a href="#" className='d-block me-4'>TERMS & CONDITIONS</a>
                                <a href="#" className='d-block me-4'>PRIVACY POLICY</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Footer